import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import HwUtils from '@app/helpers/HwUtils';
import { CanComponentDeactivate } from '../../guards/no-back.guard';
import { HeaderService } from '@app/services/header.service';

@Component({
  selector: 'id-verification-ok',
  templateUrl: './id-verification-ok.component.html',
  styleUrls: ['./id-verification-ok.component.scss']
})
export class IdVerificationOkComponent implements OnInit, CanComponentDeactivate {
  canLeave: boolean = false;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private headerService: HeaderService) { }

  line1: string
  line2: string;
  ngOnInit() {
    this.headerService.setNavigationVisibility(false);
    HwUtils.log("IdVerificationOkComponent ngOnInit");
    window.history.pushState(null, null, window.location.href);
    this.line1 = this.translate.instant("id_verif_ok.line1")
    this.line2 = this.translate.instant("id_verif_ok.line2")
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    HwUtils.log("IdVerificationOkComponent popstate detected");
    window.history.pushState(null, null, window.location.href);
  }

  forwardClick() {
    this.canLeave = true;
    this.router.navigateByUrl('/vizadata')
  }

  canDeactivate(): boolean {
    return this.canLeave;
  }
}
